export interface ILobbyURLOptions {
  folderOnly?: boolean;
}

export const getLobbyURL = (
  lobbyVersion: string | undefined,
  searchParams: string,
  options?: ILobbyURLOptions
): string => {
  let folder = 'lobby2';
  if (lobbyVersion === '1') {
    folder = 'lobby';
  }
  if (options?.folderOnly) {
    return folder;
  }
  return `/desktop/${folder}/${searchParams}`;
};
